import isEmpty from 'lodash/isEmpty'
import type { Chat } from '@ztechapps/common.contract'

/** The `metadata` keys that link a conversation to a document — order, purchase order, logistics. */
export const documentLinkFields = ['orderId', 'purchaseOrderId', 'logisticId'] as const

/** The document-link kinds a conversation carries — order, purchase order, logistics. */
export const documentLinkKinds = (chat: Chat) => documentLinkFields.filter((kind) => !isEmpty(chat?.metadata?.[kind]))
